import React from "react"

const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.98465 7.4146V9.24691H8.15234V11.9953H9.98465V20.2406H13.6492V11.9953H16.0861L16.3976 9.24691H13.6492V7.64363C13.6492 6.9016 13.7225 6.50763 14.8676 6.50763H16.3976V3.75H13.9424C11.0107 3.75008 9.98465 5.12425 9.98465 7.4146Z"
        fill="white"
      />
    </svg>

    // <svg
    //   width="6"
    //   height="10"
    //   viewBox="0 0 6 10"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M2.03233 2.26778V3.3587H0.941406V4.99506H2.03233V9.90414H4.21413V4.99506H5.66505L5.85048 3.3587H4.21413V2.40414C4.21413 1.96234 4.25777 1.72778 4.93956 1.72778H5.85048V0.0859375H4.38869C2.64325 0.0859844 2.03233 0.90414 2.03233 2.26778Z"
    //     fill="white"
    //   />
    // </svg>
  )
}
export default FacebookIcon
